



































import mixins from 'vue-typed-mixins';
import { ShortTextOptions } from '.';

export default mixins().extend({
  props: {
    value: {
      type: Object as () => ShortTextOptions,
    },
  },

  computed: {
    rules(): any {
      return [
        {
          text: this.$tc(
            'model.question.options.short_text.options.rules.none'
          ),
          value: null,
        },
        {
          text: this.$tc(
            'model.question.options.short_text.options.rules.email'
          ),
          value: 'email',
        },
        {
          text: this.$tc('model.question.options.short_text.options.rules.url'),
          value: 'url',
        },
        {
          text: this.$tc(
            'model.question.options.short_text.options.rules.regex'
          ),
          value: 'regex',
        },
      ];
    },
  },

  watch: {
    'value.rule'() {
      this.value.regex = undefined;
      if (!this.value.rule) {
        this.value.errorMessage = this.$languageobj();
      }
    },
  },

  mounted() {
    // set  values to defaults
    this.$emit('input', {
      rule: this.value?.rule || null,
      regex: this.value?.regex,
      errorMessage: this.value?.errorMessage || this.$languageobj(),
    });
  },
});
